import { useInfiniteQuery } from '@tanstack/react-query';
import { SearchStoreItemsRequest, SearchStoreItemsResponse, StoreItemSort } from '@joc/api-gateway/lib/api-client';
import { API } from '../../../core/API';
import { INITIAL_PAGINATION, STORE_ITEMS_QUERY_KEY } from '../../../core/constants';

const fetchStoreItems = async ({
	skip,
	take,
	search,
	sort,
}: {
	skip: number;
	take: number;
	search?: string;
	sort?: StoreItemSort;
}): Promise<SearchStoreItemsResponse> =>
	API.searchStoreItemByAdmin(
		undefined,
		SearchStoreItemsRequest.fromJS({
			pagination: {
				skip,
				take,
			},
			sort,
			...(search ? { search } : {}),
		})
	);

export const useStoreItems = (search: string, sort?: StoreItemSort) =>
	useInfiniteQuery<SearchStoreItemsResponse, unknown>({
		queryKey: [STORE_ITEMS_QUERY_KEY, { search, sort }],
		initialPageParam: 0,
		refetchOnWindowFocus: false,
		queryFn: ({ pageParam = 0 }) =>
			fetchStoreItems({ skip: pageParam as number, take: INITIAL_PAGINATION.take, search, sort }),
		getNextPageParam: (lastPage, allPages) => {
			return lastPage.records.length < INITIAL_PAGINATION.take ? undefined : allPages.length * 10;
		},
	});
